import './Home.css';

function Home() {
  const navigateTo = (path) => {
    window.history.pushState({}, '', path);
    window.dispatchEvent(new PopStateEvent('popstate'));
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="home">
      <section className="home-hero">
        <div className="home-hero__content">
          <h1>CarbCareUSA</h1>
          <p>
            Precision carburetors, rebuild kits, and marine fuel systems. Built for
            restorations, hot rods, marine engines, and specialty applications.
          </p>

          <div className="home-hero__buttons">
            <button
              type="button"
              className="home-btn home-btn--primary"
              onClick={() => navigateTo('/products')}
            >
              Browse Carburetors
            </button>

            <a
              href="https://carbcareusa.com"
              className="home-btn home-btn--secondary"
              target="_blank"
              rel="noreferrer"
            >
              Visit Store
            </a>
          </div>
        </div>

        <div className="home-hero__media">
          <img src="/assets/images/home/hero.jpg" alt="Carburetor showcase" />
        </div>
      </section>

      <section className="home-features">
        <div className="home-feature">
          <h3>Classic Carburetors</h3>
          <p>
            Stromberg, Rochester, Holley, Carter and more. Our catalog focuses on
            legendary carburetor families used across classic engines.
          </p>
        </div>

        <div className="home-feature">
          <h3>Marine Systems</h3>
          <p>
            Marine carburetors engineered for corrosion resistance and stable fuel
            delivery in demanding water environments.
          </p>
        </div>

        <div className="home-feature">
          <h3>Rebuild Kits</h3>
          <p>
            Professional rebuild kits designed for reliability and restoration
            projects where precision matters.
          </p>
        </div>
      </section>

      <section className="home-categories">
        <h2>Popular Categories</h2>

        <div className="home-categories__grid">
          <button
            type="button"
            className="home-category"
            onClick={() => navigateTo('/products#stromberg97')}
          >
            <img src="/assets/images/stromberg97/main.jpg" alt="Stromberg 97" />
            <span>Stromberg 97</span>
          </button>

          <button
            type="button"
            className="home-category"
            onClick={() => navigateTo('/products#marine')}
          >
            <img src="/assets/images/marine/main.jpg" alt="Marine Carburetors" />
            <span>Marine Carburetors</span>
          </button>

          <button
            type="button"
            className="home-category"
            onClick={() => navigateTo('/products#rochester_two_barrel')}
          >
            <img
              src="/assets/images/rochester_two_barrel/main.jpg"
              alt="Rochester Two Barrel"
            />
            <span>Rochester Two Barrel</span>
          </button>

          <button
            type="button"
            className="home-category"
            onClick={() => navigateTo('/products#holley_four_barrel_4160')}
          >
            <img
              src="/assets/images/holley_four_barrel_4160/main.jpg"
              alt="Holley 4160"
            />
            <span>Holley 4160</span>
          </button>
        </div>
      </section>

      <section className="home-video">
        <div className="home-video__text">
          <h2>See CarbCare In Action</h2>
          <p>
            Watch rebuild demonstrations, engine testing clips, and installation
            walkthroughs from our carburetor catalog.
          </p>
        </div>

        <video controls className="home-video__player">
          <source src="/assets/videos/home/preview.mp4" type="video/mp4" />
        </video>
      </section>

      <section className="home-cta">
        <h2>Find The Right Carburetor</h2>
        <p>
          Browse our complete carburetor catalog organized by manufacturer,
          application, and performance type.
        </p>

        <button
          type="button"
          className="home-btn home-btn--primary"
          onClick={() => navigateTo('/products')}
        >
          Explore Products
        </button>
      </section>
    </div>
  );
}

export default Home;